/*
 * Copyright © 2015-2019 Serenova, LLC. All rights reserved.
 */

import { selectFormInitialValues, getCurrentFormValues, getCurrentForm } from '../../form/selectors';
import {
  getSelectedSubEntityId,
  getSelectedEntity,
  getCurrentEntityStore,
  getSelectedEntityId,
  getAllEntities,
} from '../selectors';
import { Map, List, fromJS } from 'immutable';
import { createSelector } from 'reselect';
import { entitiesMetaData } from '../metaData';
import { handlePendingSubmitAction, submitTermsForm,submitAlpsDataForm,setTermsForm,changeVersionForm } from './actions';
import { Toast } from 'cx-ui-components';


export const selectAlpsFormInitialValues = (state) => {
  if (getSelectedEntity(state) === undefined) {
    return new Map({
      active: true,
      name: '',
      description: '',
      artifactTypeName: '',
      artifactTypeId: '',
      artifactType: '',
      artifactSubType: '',
    });
  }
  return selectFormInitialValues(state);
};

export const setAlpsFomrValues = (values, dispatch, props) => {
  return dispatch(submitAlpsDataForm(values));
};

export const getSubmitSource = createSelector(
  [getSelectedEntity, getSelectedSubEntityId, selectFormInitialValues, getCurrentEntityStore],
  (selectedEntity, selectedSubEntityId, formInitialValues, currentEntityStore) => currentEntityStore.get('submitSource'));

export const selectViewVersionFormInitialValues = createSelector(
  [getSelectedEntity, getSelectedSubEntityId, selectFormInitialValues,getCurrentEntityStore],
  (selectedEntity, selectedSubEntityId, formInitialValues,currentEntityStore) => {
    const selectedSubEntity = currentEntityStore
      .get('artifactVersions')
      .find((version) => version.versionId === selectedSubEntityId);
   if (selectedSubEntity && selectedEntity) {
      return fromJS({
        artifactTypeId: selectedEntity.get('artifactTypeId'),
        artifactTypeName: selectedEntity.get('artifactTypeName'),
        artifactType: selectedEntity.get('artifactType'),
        artifactSubType: selectedEntity.get('artifactSubType'),
        name: selectedEntity.get('name'),
        description: selectedEntity.get('description'),
     //   after: selectedEntity.get('after'),
     versionName: selectedSubEntity.versionName,
     activeAction: selectedSubEntity.activeAction,
     activeDuration:selectedSubEntity.activeDuration,
     archiveAction:selectedSubEntity.archiveAction,
     archiveDuration:selectedSubEntity.archiveDuration
      });
    }
    return formInitialValues;
  }
);

export const selectCreateVersionFormInitialValues = createSelector(
  [selectAlpsFormInitialValues],
  (alpInitialValues) => {
    return alpInitialValues.merge({
      action: '',
      after: '',
      name: '',
      description: '',
    });
  }
);

export const selectTermsFormInitialValues = (state) => {
  return new Map({
    storageLimitCosts: false,
    billingPerGB: false,
    retrieveFromStorage: false,
    deletedArtifacts: false,
  });
};

export const getCurrentParentFormValues = createSelector([getCurrentFormValues], (currentFormValues) =>
  currentFormValues.toJS()
);

export const selectAlpsVersions = (state) => {
  const selectedEntity = getSelectedEntity(state);
  const versions = state.get('Entities')?.get("alps")?.get("artifactVersions") ? state.get('Entities')?.get("alps")?.get("artifactVersions") : [];
  if (Array.isArray(versions)) {
    let userDataID = state.getIn(['Entities','users', 'data']).map(item => item.get('id'));
    let data = versions.map(item => {
      if (userDataID.includes(item.createdBy)) {
        let idx = userDataID.findIndex((userId) => userId === item.createdBy);
        let data = state.getIn(['Entities','users', 'data']).get(idx);
        item.createdBy = data.get('firstName') + ' ' + data.get('lastName');
        return item;
      }
      return item;
    });
    return data;
  }
 return [];
}

export const isToggleEnabled = createSelector([getCurrentEntityStore], (entityStore) =>
   entityStore.get('artifactVersions') !== undefined 
   ? entityStore.get('artifactVersions').some(versions =>
      versions.enable == true
    )
    :false)

export const isToggleDisabled = (isToggleEnabled, userHasUpdatePermission, userHasDisablePermission) => {
  if (isToggleEnabled == false && userHasUpdatePermission == false) {
    return true;
  } else if (isToggleEnabled == true && userHasDisablePermission == false) {
    return true;
  } else {
    return false;
  }
}

export const selectAlpsHistory = createSelector([getCurrentEntityStore], (entityStore) =>
  entityStore.get('artifactHistory') == undefined ? [] : entityStore.get('artifactHistory')
);

export const isTermsFormOpen = createSelector([getCurrentEntityStore], (entityStore) =>
  entityStore.get('termsFormOpen')
);

export const getPendingSubmit = createSelector([getCurrentEntityStore], (entityStore) =>
  entityStore.get('pendingSubmit')
);

export const changeVersionIdSubmit = createSelector([getCurrentEntityStore], (entityStore) =>
  entityStore.get('changeVersionId')
);
export const handlePendingSubmit = (values, dispatch, props, state) => {
  if (props.form.includes('alpsVersion:')) {
    return dispatch(handlePendingSubmitAction(values, dispatch, props, 'createVersion'));
  } else if (props.form === 'alps:create') {
    return dispatch(handlePendingSubmitAction(values, dispatch, props, 'createPolicy'));
  } else if (props.form === 'amr:create') {
    return dispatch(handlePendingSubmitAction(values, dispatch, props, 'createPolicy'));
  }

  let submitSource = '';
  const differentValues = values.filter((v, k) => props.initialValues.get(k) !== v).toJS();
  const { activeVersion, active } = differentValues;
  if (activeVersion !== undefined) {
    const currentEntity = getSelectedEntity(state);
    const newActiveVersion = currentEntity.get('versions').find((version) => version.get('id') === activeVersion);
    if (newActiveVersion) {
      values = values.merge(newActiveVersion);
    }
    submitSource = 'changeVersion';
  } else if (active !== undefined) {
    submitSource = active ? 'enablePolicy' : 'disablePolicy';
  } else {
    console.error('Form was submitted but values are unchanged from initialization.');
    return Toast.error('Cannot submit an unchanged form.');
  }
  return dispatch(handlePendingSubmitAction(values, dispatch, props, submitSource));
};

export const changeVersion = (versionId, dispatch, props) => {
  return dispatch(setTermsForm(true,"changeVersion",versionId));
    //return dispatch(changeVersionForm(versionId, dispatch, props));
}

export const handleTermsSubmit = (values, dispatch, props) => {
  return dispatch(submitTermsForm());
};

export const getSelectableVersionList = (state) => {
  const data = state.get('Entities')?.get("alps")?.get("artifactVersions");
  let versionList = data?.map((val) => {
    return ({ value: val.versionId, label: `${val.versionNum} - ${val.versionName}`})
  });
  if(versionList){
    return versionList;
  }else{return [];}
}

export const isCreatingEntity = createSelector(
  [getSelectedEntityId],
  (selectedEntityId) => selectedEntityId === 'create'
);

export const selectTypes = createSelector([getCurrentEntityStore], (entityStore) => {
  return entityStore.get('artifactTypes')
});

export const selectTypesForDisplay = createSelector([selectTypes,getCurrentEntityStore], (types,currentEntityStore) => {
  const data = types.map((type) => ({
    label: type.artifactTypeName,
    value: type.artifactTypeId,
  }));
  return data
}
);

export const selectAlpsTypesForDisplay = createSelector([selectTypes, getCurrentEntityStore], (types, currentEntityStore) => {
  let alpsList = currentEntityStore.get('data').toJS().map(item => item.artifactTypeId);

  const alpsTypesData = types.filter((type) =>
    alpsList.includes(type.artifactTypeId) == false || type.artifactTypeName == "Audio Recording" 
  );
  const data = alpsTypesData.map((type) => ({
    label: type.artifactTypeName,
    value: type.artifactTypeId,
  })
  )
  return data;
});

export const selectExistingTypes = createSelector([getAllEntities], (entities) =>
  entities.map((entity) => entity.get('artifactType'))
);

export const selectExistingSubtypes = createSelector([getAllEntities], (entities) =>
  entities.map((entity) => entity.get('artifactSubtype'))
);

const findLabelForValue = (value, labelList) => {
  const foundObj = labelList && labelList.find((labelObj) => labelObj.value === value);
  return foundObj && foundObj.label;
};

export const selectTypeLabel = createSelector([getSelectedEntity], (alp) => {return alp.get('artifactTypeName')});

export const selectSubTypeLabel = createSelector([getSelectedEntity], (alp) => {
  return alp && (alp.get('artifactSubType') == "null" ? "" : alp.get('artifactSubType'))
});


export const getArtifactVersions = createSelector([getCurrentEntityStore], (entityStore) => {
  return entityStore.get('artifactVersions')
});

export const artifactData = createSelector([getCurrentEntityStore], (entityStore) => {
  return entityStore.get('data') == undefined ? [] : entityStore.get('data')
});

export const selectTypeLabelText = createSelector([selectTypes, getPendingSubmit, getArtifactVersions, getCurrentEntityStore], (types, pendingSubmit, artifactVersions, currentEntityStore) => {
  let artifactTypeId = "";
  if (pendingSubmit !== undefined && pendingSubmit.size > 0 && pendingSubmit.get('artifactTypeId')!==undefined) {
    artifactTypeId = pendingSubmit.get('artifactTypeId');
  }
  else if (artifactVersions !== undefined && artifactVersions.length > 0) {
    artifactTypeId = artifactVersions.map(item => item.artifactTypeId)[0]
  }
  const data = types.find((type) => type.artifactTypeId == artifactTypeId);
  if (data) {
    return data.artifactTypeName
  } else { return "" }
});

export const selectSubTypeLabelText = createSelector([selectTypes, getPendingSubmit, getArtifactVersions, getCurrentEntityStore, selectSubTypeLabel], (types, pendingSubmit, artifactVersions, currentEntityStore, selectSubTypeLabel) => {
  let artifactSubType = ''; 
  if (pendingSubmit !== undefined && pendingSubmit.size > 0 && pendingSubmit.get('artifactSubType') !== undefined && pendingSubmit.get('artifactSubType') !== "null") {
    artifactSubType = pendingSubmit.get('artifactSubType');
  }
  else {
    artifactSubType = selectSubTypeLabel;
  }
  return artifactSubType;
});

export const getActiveAction = createSelector([getCurrentEntityStore], (currentEntityStore) => {
  return currentEntityStore.get('checkActiveAction')
});

export const selectSubtypeLabel = createSelector([getSelectedEntity], (alp) =>
  findLabelForValue(alp.get('artifactSubType'), entitiesMetaData.alps.artifactSubtypes)
);

const typeHasSubtypes = (types, selectedArtifactType) => {
  const matchingType = types.find((type) => (type.artifactTypeName === selectedArtifactType || type.artifactTypeId === selectedArtifactType));
  return matchingType && matchingType.hasSubtypes;
};

export const valueTypeHasSubtypes = (state, searchType) => {
  return typeHasSubtypes(selectTypes(state), searchType);
};

export const formTypeHasSubtypes = createSelector([getCurrentForm, selectTypes], (currentForm, types) => {
  const selectedArtifactType = currentForm && currentForm.getIn(['values', 'artifactTypeId']);
  return typeHasSubtypes(types, selectedArtifactType);
});

